import i18n from '../../i18n';

/**
 * Format a date string or timestamp into a readable format
 * @param {string|number|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleString('en-US', {
        includeDate: true,
        includeTime: true,
        dateStyle: 'medium',
        timeStyle: 'short',
    });
};

/**
 * Format file size in bytes to a human-readable string
 * @param {number} bytes - The size in bytes
 * @param {number} decimals - Number of decimals to show (default 2)
 * @returns {string} Formatted file size
 */
export const formatFileSize = (bytes, decimals = 2) => {
    // Only the spelled-out "Bytes" is translated — KB/MB/GB… are the same
    // abbreviations in every locale we ship.
    const bytesUnit = i18n.t('common:units.bytes');
    if (bytes === 0) return `0 ${bytesUnit}`;

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [bytesUnit, 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Get file extension from filename
 * @param {string} filename 
 * @returns {string} extension (without dot)
 */
export const getFileExtension = (filename) => {
    return filename?.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
};
